import React from "react";
import { Box, Typography, Button } from "@mui/material";
import historyStyle from "./historyStyle";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import historyImg1 from "../../../../assets/images/history.jpg";
import historyImg2 from "../../../../assets/images/history2.jpg";
import { scrollToProjectEnd } from "../../../../utils/scrollToProjectEnd";

const History = ({ onClose }) => {
  const classes = historyStyle();

  return (
    <Box className={`${classes.detailsContainer} ${classes.fadeIn}`}>
      <Box className={classes.detailsSection}>
        <Typography className={classes.header}>
          Story of Paketposthalle
        </Typography>

        {/* First Row: Image Left, Text Right */}
        <Box className={classes.detailsRow}>
          <Box className={classes.imageContainer}>
            <Box className={classes.detailsImage} style={{ backgroundImage: `url(${historyImg1})` }} />
            <Typography variant="caption" className={classes.imageCopyright}>
              © Image by H&dM
            </Typography>
          </Box>
          <Box className={classes.detailsText}>
            <Typography variant="body1" className={classes.paragraph}>
              The Paketposthalle in Munich, built between 1965 and 1969, was originally a parcel distribution center designed to support growing postal logistics.
              Owned by Deutsche Post, it featured one of the world’s largest freestanding precast concrete structures and included 15 railway tracks to facilitate efficient mail transport.
              From 1969 to 1996, it served as Munich’s central parcel hub before being granted heritage status in recognition of its engineering significance.
            </Typography>
          </Box>
        </Box>

        {/* Second Row: Text Left, Image Right */}
        <Box className={classes.detailsRow}>
          <Box className={classes.detailsText}>
            <Typography variant="body1" className={classes.paragraph}>
              After postal restructuring in 1998, the hall was repurposed as a mail processing center under Deutsche Post AG.
              In 2018, the Büschl Group acquired the property, including its surrounding 
              100,000 square meters of land, while its heritage status ensured preservation. 
              Today, the Paketposthalle remains a historically significant landmark, 
              reflecting Munich's industrial and logistical development.
            </Typography>
          </Box>
          <Box className={classes.imageContainer}>
            <Box className={classes.detailsImage} style={{ backgroundImage: `url(${historyImg2})` }} />
            <Typography variant="caption" className={classes.imageCopyright}>
              © Image by State Office for Digitalization, Broadband and Surveying
            </Typography>
          </Box>
        </Box>
        
        {/* Collapse Button */}
        <Button className={classes.collapseButton} onClick={() => scrollToProjectEnd(onClose)}>
          <ExpandLessIcon />
        </Button>
      </Box>
    </Box>
  );
};

export default History;
